import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  SelectInput,
  FilterButton,
  TopToolbar,
  ExportButton,
  SearchInput,
  FunctionField,
  NumberInput,
} from 'react-admin';
import { Chip } from '@mui/material';

const eventFilters = [
  <SearchInput
    key="search"
    source="q"
    placeholder="Search by chat title or event ID"
    alwaysOn
  />,
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: 'SCHEDULED', name: 'Scheduled' },
      { id: 'ACTIVE', name: 'Active' },
      { id: 'ENDED', name: 'Ended' },
      { id: 'CANCELLED', name: 'Cancelled' },
    ]}
    label="Status"
  />,
  <NumberInput key="chat_id" source="chat_id" label="Chat ID" />,
  <NumberInput key="owner_id" source="owner_id" label="Owner ID" />,
];

const EventListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

const StatusField = ({ source }: { source: string }) => (
  <FunctionField
    source={source}
    render={(record: any) => {
      const status = record[source];
      let color: 'default' | 'primary' | 'success' | 'error' | 'warning' | 'info' = 'default';

      switch (status) {
        case 'SCHEDULED':
          color = 'info';
          break;
        case 'ACTIVE':
          color = 'success';
          break;
        case 'ENDED':
          color = 'default';
          break;
        case 'CANCELLED':
          color = 'error';
          break;
        default:
          color = 'default';
      }

      return <Chip label={status} color={color} size="small" />;
    }}
  />
);

const PaymentStatusField = ({ source }: { source: string }) => (
  <FunctionField
    source={source}
    render={(record: any) => {
      const status = record[source];
      if (!status) return <span>-</span>;

      let color: 'default' | 'primary' | 'success' | 'error' | 'warning' = 'default';

      switch (status) {
        case 'PAID':
          color = 'success';
          break;
        case 'PENDING':
          color = 'warning';
          break;
        case 'FAILED':
          color = 'error';
          break;
        default:
          color = 'default';
      }

      return <Chip label={status} color={color} size="small" />;
    }}
  />
);

const PoolField = ({ record }: { record: any }) => {
  const referralPool = (record.estimated_referral_turnover || 0) *
                      (record.referral_share_percent || 0) / 100 * 0.01;
  const additionalPool = record.additional_pool_amount || 0;
  const totalPool = referralPool + additionalPool;

  if (totalPool === 0) return <span>-</span>;

  return (
    <span>
      {totalPool.toFixed(2)} {record.additional_pool_currency || 'TON'}
    </span>
  );
};

export const EventList = () => (
  <List
    filters={eventFilters}
    actions={<EventListActions />}
    perPage={50}
    sort={{ field: 'event_id', order: 'DESC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="event_id" label="ID" />
      <StatusField source="status" />
      <TextField source="chat_title" label="Chat" />
      <TextField source="chat_username" />
      <TextField source="owner_username" label="Owner" />
      <DateField source="start_time" showTime label="Start" />
      <DateField source="end_time" showTime label="End" />
      <FunctionField
        label="Prize Pool"
        render={(record: any) => <PoolField record={record} />}
      />
      <NumberField source="top_positions" label="Positions" />
      <PaymentStatusField source="payment_status" />
      <DateField source="created_at" showTime label="Created" />
    </Datagrid>
  </List>
);
